<template>

  <van-cell center
            :class="{'y_cell-activity-code':cellType===3}"
            value-class="phone_c">
    <template #title>
      <span v-show="cellType===2" class="custom-title">兑换码</span> <br v-show="cellType===2">
      <span v-show="cellType===2">{{ CDKey }}</span>
      <span v-show="cellType===3" style="font-size: 14px">手机号{{ mobileNo|phoneFilter }} </span><span></span>
      <span v-show="cellType===1" style="font-size: 14px">手机号{{mobileNo|phoneFilter}} </span>


      <span class="y_tag" v-show="cellType===3&&status==='0'">(充值中)</span>
      <span class="y_tag" v-show="cellType===3&&status==='1'">(充值成功)</span>
      <!--      <span v-show="status===2">(充值中)</span>-->
      <van-button plain
                  v-show="cellType===3&&status==='2'"

                  @click="toPrepaidRefill"

                  hairline
                  size="mini"
                  round
                  color="#2FBD4B"
                  style="padding-left: 0.5em;padding-right: 0.5em;margin-left: 1em;"
                  type="info">充值失败点击重试
      </van-button>
    </template>
    <template #label>
      <span v-show="cellType===2">{{ createTime|DateFilter }}</span>
    </template>
    <span v-show="cellType===3||cellType===1" style="color: #999999;font-size: 12px">{{ createTime|DateFilter }}</span>
    <van-button plain
                v-show="cellType===2&&status==='01'"
                data-clipboard-action="copy"
                :data-clipboard-text="CDKey"
                @click="copyExchangeCode"
                :class="'cobyOrderSn'+orderNo"
                hairline
                size="mini"
                round
                color="#595959"
                style="padding-left: 0.4em;padding-right: 0.4em; margin-left: 0.5em;"
                type="info">复制兑换码
    </van-button>
    <van-button plain
                v-show="cellType===2&&status==='02'"
                data-clipboard-action="copy"
                :data-clipboard-text="CDKey"
                @click="rechargeGetCode"
                :class="'cobyOrderSn'+orderNo"
                hairline
                size="mini"
                round
                color="#595959"
                style="padding-left: 0.4em;padding-right: 0.4em; margin-left: 0.5em;"
                type="info">重新获取
    </van-button>

  </van-cell>


</template>

<script>
import {ygetDate, deepClone} from "@/libs/tools";
// import {
//   recharge
// } from "@/services/api";

export default {
  name: "cellActivitionCode",
  props: {
    logInfo: {
      type: Object
    },
    cellType: {
      type: Number
    },
    mobileNo: {
      type: [Number, String]
    },
    createTime: {
      type: Number
    },
    CDKey: {
      type: String
    },
    productId: {
      type: String
    },
    status: {
      type: String
    },
    orderNo: {
      type: String
    }

  },
  filters: {
    DateFilter(val) {
      return ygetDate(val, 'date')
    },
    phoneFilter: function (tel) {
      // var tel = 19812311111;
      tel = "" + tel;
      // d表示数字0-9,{3}表示需要3个，所以d{3}就是表示3个数字
      var reg = /(\d{3})\d{4}(\d{4})/;
      //$1是第一个小括号里的 ,$2是第2个小括号里的
      return tel.replace(reg, "$1****$2")

    }
  },
  methods: {
    copyExchangeCode() {
      let _this = this;
      let zClassName = '.cobyOrderSn' + this.orderNo
      let clipboard = new this.clipboard(zClassName);
      clipboard.on('success', function () {
        _this.$toast("复制成功")
      });
      clipboard.on('error', function () {
        _this.$toast("复制失败")
      });
    },
    rechargeGetCode(){
      let that = this

      this.$emit("prepaidRefill", deepClone(that.logInfo));//自定义事件  传递值“子向父组件传值”
    },
    toPrepaidRefill() {
      // eslint-disable-next-line no-unused-vars
      let that = this

      this.$emit("prepaidRefill", deepClone(this.logInfo));//自定义事件  传递值“子向父组件传值”
      // let robj = new FormData();
      //
      // robj.append('token', this.$store.state.user.token)
      // robj.append('deviceCoding', this.$store.state.user.deviceCoding)
      // robj.append('activityNo', this.$store.state.activityNo)
      // robj.append('mobileNo', this.dialogPhone)
    }
  }
}
</script>

<style scoped>
.y_tag {

  font-size: 12px;

  font-weight: 400;
  color: #999999;
  margin-left: 1em;


}

.phone_c {
  flex: initial;
}

</style>